export enum SearchWidgetFiltersPageEnum {
  MAIN = 'main',
  CARE_SERVICE_UNIT_GROUPS = 'careServiceUnitGroups',
  CARE_SERVICE_UNITS = 'careServiceUnits',
  CARE_SERVICE_TYPE_GROUPS = 'careServiceTypeGroups',
  CARE_SERVICE_TYPES = 'careServiceTypes',
  SYMPTOMS_GROUPS = 'symptomsGroups',
  SYMPTOMS = 'symptoms',
}
